<template>
  <!--
      	作者：zhuchangtao
      	时间：2021-03-30
      	描述：题库-题目列表
      -->
  <div>
     <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
       <el-form-item label="标题"><el-input size="small" v-model="searchForm.title" placeholder="请输入标题"></el-input></el-form-item>

       <el-form-item label="类型">
         <el-select size="small" v-model="searchForm.type" placeholder="请选择">
           <el-option label="全部" value=""></el-option>
           <el-option label="单选" value="10"></el-option>
           <el-option label="多选" value="20"></el-option>


         </el-select>
       </el-form-item>

       <el-form-item label="起始时间">
         <div class="block">
           <span class="demonstration"></span>
           <el-date-picker
             size="small"
             v-model="searchForm.create_time"
             type="daterange"
             value-format="yyyy-MM-dd"
             range-separator="至"
             start-placeholder="开始日期"
             end-placeholder="结束日期"
           ></el-date-picker>
         </div>
       </el-form-item>
       <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item>
          <el-button type="primary" @click="openUpload" v-auth="'/topic/delivery/csv'">导入题目</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="down" v-auth="'/topic/topic/export'">导入格式下载</el-button>
        </el-form-item>
     </el-form>
    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addtopic" v-auth="'/topic/topic/add'">添加题目</el-button></div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" border v-loading="loading">
        <el-table-column prop="topic_id" label="题目ID" width="60"></el-table-column>

        <el-table-column prop="title" label="题目内容">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.title">{{scope.row.title}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="type.text" label="题目类型" width="180"></el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="180"></el-table-column>

        <el-table-column prop="name" label="操作" width="280">
          <template slot-scope="scope">
            <el-button @click="edittopic(scope.row)" type="text" size="small" v-auth="'/topic/topic/edit'">编辑</el-button>
            <el-button @click="deletetopic(scope.row)" type="text" size="small" v-auth="'/topic/topic/delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <FileUpload v-if="open_add" :open_add="open_add"  @closeDialog="closeDialogFunc($event, 'add')"></FileUpload>
  </div>
</template>

<script>
import TopicApi from '@/api/topic.js';
import qs from 'qs';
import FileUpload from './dialog/FileUpload';
export default {
  components: {
    /*文件上传*/
    FileUpload: FileUpload,
  },
  data() {
    return {
      /*横向表单数据模型*/
      searchForm: {
        title: "",
        type:'',
        create_time: ''
      },
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    };
  },
  created() {
    /*获取题目列表*/
    this.getTableList();
  },
  methods: {
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getTableList();
    },
    /*获取题目列表*/
    getTableList() {
      let self = this;
      let Params = this.searchForm;
      Params.page = self.curPage;
      TopicApi.topiclist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*添加题目*/
    addtopic() {
      this.$router.push({
        path: '/topic/topic/add'
      });
    },

    /*编辑题目*/
    edittopic(row) {
      let params = row.topic_id;
      this.$router.push({
        path: '/topic/topic/edit',
        query: {
          topic_id: params
        }
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getTableList();
    },

    /*删除题目*/
    deletetopic(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          TopicApi.deletetopic(
            {
              topic_id: row.topic_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },



    handleClick(tab, event) {},

    /*打开分类添加*/
    addCategory() {
      this.open_add = true;
    },

    /*打开分类编辑*/
    editCategory(item) {
      this.userModel = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },
    /*导出格式*/
    down: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/topic.topic/export?' + qs.stringify(this.searchForm);
    },
    /*批量导入*/
    openUpload() {
      this.open_add = true;
    },
    /*获取批量文件*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        // this.file_id = e[0].file_id;
        // this.path = e[0].file_path;
        let params = {};
        params.file_id = e[0].file_id;
        console.log(params)
        self.loading = true;
        TopicApi.batchDelivery(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: data.msg,
              type: 'success'
            });
            self.$router.push('/topic/topic/index');
          })
          .catch(error => {
            self.loading = false;
          });

      }
      this.isupload = false;
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/topic/topic/index.vue